import { connect } from 'react-redux';
import FlagWindowWarning from './FlagWindowWarning';
import config from '../../../../helpers/config';

const mapDispatchToProps = undefined;

const mapStateToProps = () => {
  const phoneNumber = config.mandiCECPhoneNumber;
  return { phoneNumber };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlagWindowWarning);
